<script>
    import { metaInfo } from "@/core/MetaInfo";
    import BaseAccordion from "@main/packages/BaseAccordion";
    import TypographyWrapper from "@/components/TypographyWrapper";
    import { mapGetters } from "vuex";

    export default {
        name: "DocumentLoyaltyFaq",
        components: { BaseAccordion, TypographyWrapper },
        data() {
            return {
                activeIndex: 0,
            };
        },
        computed: {
            ...mapGetters("Root", ["currency"]),
            text() {
                return [
                    {
                        title: "Как зарегистрироваться?",
                        desc: "<p>Для открытия бонусного счета клиента, необходимо заполнить регистрационную форму в&nbsp;интернет-магазине Madrobots.</p>",
                    },
                    {
                        title: "Как получить бонусы?",
                        desc: "<ol><li>Совершайте покупки в&nbsp;интернет-магазине и&nbsp;получайте до&nbsp;7% от&nbsp;вашей покупки на&nbsp;ваш бонусный счет.</li><li>Оформите подписку на&nbsp;email-рассылки интернет-магазина и&nbsp;получайте дополнительные персональные скидки, а&nbsp;также будьте в&nbsp;курсе новинок и&nbsp;акций Madrobots.</li><li>Оформите подписку на&nbsp;наши группы в&nbsp;социальных сетях и&nbsp;получайте специальные предложения.</li></ol>",
                    },
                    {
                        title: "Как узнать, сколько у меня бонусов?",
                        desc: "<p>Узнать баланс участник может в&nbsp;личном кабинете.</p>",
                    },
                    {
                        title: "Как потратить бонусы?",
                        desc: "<p>Бонусами можно оплатить любую покупку в&nbsp;корзине интернет-магазина Madrobots до&nbsp;100% покупки.</p>",
                    },
                    {
                        title: "Что такое Мэдкоин?",
                        desc: `<p>Мэдкоин&nbsp;&mdash; это внутренняя валюта Madrobots, он&nbsp;же бонус.&nbsp;1&nbsp;мэдкоин = 1&nbsp;бонусу = 1&nbsp;${this.currency}.</p>`,
                    },
                    {
                        title: "Я получил свой заказ, но не получил баллы. Что делать?",
                        desc: "<p>Бонусные баллы начисляются на&nbsp;счет участника программы и&nbsp;доступны для списания через 14&nbsp;дней после перехода заказа в&nbsp;статус &laquo;Выполнен&raquo;.</p>",
                    },
                ];
            },
        },
        methods: {
            changeIndex(index) {
                this.activeIndex = index;
            },
        },
        metaInfo() {
            return metaInfo.getMeta("document-loyalty-faq");
        },
    };
</script>

<template>
    <div class="document-loyalty-faq">
        <div class="l-container">
            <typography-wrapper>
                <h2>
                    Программа лояльности Madrobots <br />
                    Частые вопросы
                </h2>
                <div class="document-loyalty-faq__content">
                    <base-accordion
                        v-for="(item, index) in text"
                        :key="index + 10"
                        :active-index="activeIndex"
                        :index="index"
                        :accordion="item"
                        custom-type
                        @change="changeIndex"
                    ></base-accordion>
                </div>
            </typography-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
    .document-loyalty-faq {
        padding-bottom: 56px;
        background-color: var(--document-background-color);
        h2 {
            max-width: 900px;
            margin-left: auto;
            margin-right: auto;
            text-align: center;
        }
    }

    .document-loyalty-faq__content {
        padding: 16px;
        background-color: var(--service-background-color);
        border: var(--service-border);
        border-radius: var(--service-border-radius);
        @include bp($bp-desktop-sm) {
            padding: 26px 32px 12px;
        }
    }
</style>
